"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatHumanDateTime = exports.formatHumanDate = exports.formatAddress = void 0;
const moment_1 = __importDefault(require("moment"));
const formatAddress = (address = "") => address.slice(0, 4) + "..." + address.slice(address.length - 4, address.length);
exports.formatAddress = formatAddress;
const formatHumanDate = (date) => (0, moment_1.default)(date).format("DD MMM, yyyy");
exports.formatHumanDate = formatHumanDate;
const formatHumanDateTime = (date) => (0, moment_1.default)(date).format("MMMM DD, yyyy [at] hh:mm:ss a");
exports.formatHumanDateTime = formatHumanDateTime;
